module.exports = __webpack_public_path__ + "img/2.d875f53f.png";